
import React from 'react';
import { Bitcoin, CreditCard, Linkedin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="w-full border-t pt-4">
      <div className="flex justify-between items-center">
        <div className="text-sm text-muted-foreground">
          {t('footer.developer')}
        </div>
        <div className="flex space-x-2 items-center">
          <LanguageSwitcher />
          <a 
            href="https://www.linkedin.com/in/serhat-demirkan/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-500 hover:text-blue-700"
          >
            <Linkedin size={20} />
          </a>
          <a 
            href="https://www.buymeacoffee.com" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-yellow-500 hover:text-yellow-700"
          >
            <CreditCard size={20} />
          </a>
          <a 
            href="bitcoin:ADDRESS" 
            className="text-orange-500 hover:text-orange-700"
          >
            <Bitcoin size={20} />
          </a>
        </div>
      </div>
    </div>
  );
};
